import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//注册自定义组件
import components from '@/views/visual/dataScreen/components/';
import crypto from '@/views/visual/dataScreen/js/utils/crypto';
import { dynamicSql } from '@/api/visual/db';
import { getFunction } from '@/views/visual/dataScreen/js/utils/utils';
import common from '@/views/visual/dataScreen/js/config';
import echartComponents from "../echart/";
import Vue from 'vue';
export default {
  name: 'subgroup',
  inject: ["contain", 'container'],
  provide: function provide() {
    return {
      contain: this.contain,
      container: this.container
    };
  },
  components: components,
  props: {
    nav: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      sqlFormatter: dynamicSql,
      common: common
    };
  },
  created: function created() {
    var _this = this;

    console.log('echartComponents', echartComponents);
    console.log('echartComponents', Object.keys(echartComponents));
    this.init();
    this.$nextTick(function () {
      console.log('nav', _this.nav);
    });
  },
  methods: {
    init: function init() {
      Object.keys(echartComponents).map(function (ele) {
        var component = echartComponents[ele];
        Vue.component(component.name, component);
      });
      this.getFunction = getFunction;
    },
    getItemObj: function getItemObj() {
      console.log('this.common.NAME + this.contain.activeObj.index', this.common.NAME + this.contain.activeObj.index);
      console.log('this.common.NAME + this.contain.activeObj.index', this.common);
      return this.$refs[this.common.NAME + this.contain.activeObj.index][0];
    },
    //刷新数据
    handleRefresh: function handleRefresh() {
      return this.getItemObj().updateData();
    },
    //获取对象
    getDragObj: function getDragObj(val) {
      return this.$refs["".concat(this.common.DEAFNAME).concat(val)];
    },
    handleMove: function handleMove(_ref) {
      var _this2 = this;

      var index = _ref.index,
          left = _ref.left,
          top = _ref.top;
      if (this.contain.activeIndex !== index) return;
      this.contain.activeList.forEach(function (item) {
        if (_this2.contain.activeIndex === item.index) return;
        item.left = item.left + left;
        item.top = item.top + top;
      });
    },
    handleOver: function handleOver(_ref2) {
      var index = _ref2.index;
      this.contain.overactive = index;
    },
    handleFocus: function handleFocus(_ref3) {
      var index = _ref3.index;
      this.contain.activeIndex = index;
      this.container.gradeFlag = true;
      this.contain.selectNav(index);
    },
    handleBlur: function handleBlur(_ref4) {
      var index = _ref4.index,
          left = _ref4.left,
          top = _ref4.top,
          width = _ref4.width,
          height = _ref4.height;
      if (index !== this.contain.activeIndex) return;
      this.container.gradeFlag = false;
      this.$set(this.contain.activeObj.component, 'width', width);
      this.$set(this.contain.activeObj.component, 'height', height);
      this.$set(this.contain.activeObj, 'left', left);
      this.$set(this.contain.activeObj, 'top', top);
    }
  }
};